import React, { useEffect, useState } from 'react';

import slide from '../../Assets/original/ARN_3208.JPG';
import slide1 from '../../Assets/original/ARN_3202.JPG';

const FeaturedProduct = () => {
  const slides = [slide, slide1];
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full">
      {/* Title */}
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 py-3 text-center px-4">
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 whitespace-nowrap">
          FEATURED PROJECTS
        </h1>
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
      </div>

      {/* Slide */}
      <div
        className="relative h-[60vh] sm:h-[78vh] mt-4 bg-cover bg-center bg-no-repeat transition-all duration-1000"
        style={{ backgroundImage: `url(${slides[currentSlide]})` }}
      >
        {/* Slide Indicators */}
        <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 flex gap-2 z-40">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`px-2 sm:px-3 py-0.5 rounded-xl transition-all duration-300 ${
                currentSlide === index
                  ? 'bg-gray-300 text-black font-semibold'
                  : 'bg-gray-900 text-white'
              }`}
            >
            </div>
          ))}
        </div>
      </div>

      {/* Subheading */}
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mt-16 px-4 text-center">
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        <h1 className="text-xs sm:text-2xl font-semibold text-gray-800 whitespace-nowrap">
          Explore projects in your desired locations
        </h1>
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
      </div>  

      {/* Scrolling Locations */}
      <div className="overflow-hidden w-full mb-10 max-w-screen-lg mx-auto mt-4">
        <div
          className="whitespace-nowrap animate-scroll text-lg sm:text-2xl font-serif text-[#c4b27a]"
          style={{ animation: 'scrollText 20s linear infinite' }}
        >
          {[
            'Ambur',
            'Vellore',
            
          ].map((city, index) => (
            <span key={index} className="inline-block mx-6 sm:mx-8">
              {city}
            </span>
            
          ))}

        </div>
      </div>

      {/* CTA Button */}
      <div className="flex justify-center mb-6">
        <button className="border border-black px-5 sm:px-7 py-2 text-sm sm:text-base hover:bg-black hover:text-white transition">
          EXPLORE PROJECTS
        </button>
      </div>
    </div>
  );
};

export default FeaturedProduct;
